import React, { Component } from 'react';
import { Table, Button,Alert,Tag,Icon,Popconfirm,message,Input } from 'antd';
import { Link } from "react-router-dom";
const queryString = require('query-string');
const { Search } = Input;

class GenTable extends Component {
    constructor(props) {
        super(props);
        this.state = {  filteredInfo: null,
            sortedInfo: null,
            searchvalue:'',
            filteredBranch:  [],
            columns : null,
            columnsData:null,
            dynamicData:null,
            tableData:null,
            filteredInfo:{
              branch:null,
              campus:null,
              section:null
            },
            filteredCampus:  [],
            filteredSection : [],
            selectedRowKeys: [] }
    }

    componentDidMount() {
        var parsed = queryString.parse(this.props.props.location.search);
        this.setState({tableData:this.props.data})

        if(!parsed.Branch){
          parsed.Branch=null
        }

        if(parsed.Branch){
          parsed.Branch=[parsed.Branch]
        }

        if(!parsed.Campus){
          parsed.Campus=null
        }

        if(parsed.Campus){
          parsed.Campus=[parsed.Campus]
        }

        if(!parsed.Section){
          parsed.Section=null
        }

        if(parsed.Section){
          parsed.Section=[parsed.Section]
        }

        if(parsed.Branch || parsed.Campus || parsed.Section ){
          this.setState({
                filteredBranch: [parsed.Branch],
                filteredCampus: [parsed.Campus],
                filteredSection: [parsed.Section],
                filteredInfo:  {branch : parsed.Branch, campus:parsed.Campus, section:parsed.Section}
          })
        }
        
      }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
          filteredBranch: filters.branch || [],
          filteredCampus: filters.campus || [],
          filteredSection : filters.section || [],
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearAll = () => {
        this.setState({
          filteredBranch:  [],
          filteredCampus:  [],
          filteredSection : [],
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };

      onSelectChange = (selectedRowKeys, selectedRows) => {
        const selected = Array.prototype.map
          .call(selectedRows, function(item) {
            return item.email;
          })
          .join(",");
        this.setState({ selected });
        this.setState({ selectedRowKeys });
      };
    
      sendMail = () => {
        
        window.open(
          "mailto:" + this.state.selected,
          "name",
          "height=900,width=900"
        );
      };

      searchTable = (value,dataTable) => {


        const newData= dataTable.filter(data=> Object.keys(data).filter(key => (data[key]&& ((data[key]).toString().toUpperCase()).includes((value).toUpperCase()))).length > 0 ? true: false)
        this.setState({tableData:newData})
        
       };


    render() { 
        const {profile} = this.props.props
        
        let { sortedInfo, filteredInfo,selectedRowKeys,filteredBranch, filteredCampus, filteredSection,columnsData,dynamicData,tableData } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            onSelect: this.onSelect
          };
          const columns = [
            {
              title: 'Name',
              dataIndex: 'displayName',
              key: 'displayName',
              defaultSortOrder: 'ascend',
              sorter: (a, b) => a.displayName && a.displayName.localeCompare(b.displayName),
              ellipsis: true
            },
            {
                title: 'Campus',
                dataIndex: 'campus',
                key: 'campus',
                filters: [{text: 'BVRIT',value: 'BVRIT'},{text: 'VIT',value: 'VIT'},{text: 'BVRITH',value: 'BVRITH'},{text: 'SVECW',value: 'SVECW'}],
                filteredValue: filteredInfo.campus || null,
                onFilter: (value, record) => record && record.campus && record.campus.match(new RegExp('^'+value+'$','g')),
                ellipsis: true,
              },
              {
                title: "Email",
                dataIndex: "email",
                key: "email"
              },
              {
                title: "Action",
                key: "action",
                render: (text, record) => (
                  <span>
                    <Popconfirm
    title="Are you sure to delete?"
    onConfirm={e => {
      this.props.onDelete(record.email);
    }}
    okText="Yes"
    cancelText="No"
  >
 <Button>Delete</Button>
  </Popconfirm>
                  </span>
                )
              }
          ];

          if(profile.role =='ADMIN'){
            columns.push( {
              title: 'AddedBy',
              dataIndex: 'addedBy.displayName',
              key: 'addedBy.displayName',
              render: (text, record) => (
               text
              )
            })
          }
          
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
                
              </div>

              {filteredBranch.length > 0 ||filteredCampus.length>0 || filteredSection.length>0 ? (
                <div style={{ margin: 20, background: "#f9f9f9", padding: 20 }}>
                  <Alert
                    message={`Filtered by ${filteredCampus.toString()} Campus | ${filteredBranch.toString()} Branch | ${filteredSection.toString()} Section`}
                    type="info"
                    showIcon
                  />{" "}
                  <Button
                    type="primary"
                    icon="close"
                    onClick={this.clearAll}
                    style={{ marginBottom: 25, marginTop: 10 }}
                  >
                    Clear Filters
                  </Button>{" "}
                </div>
              ) : null}

       {columns && tableData  ?  <Table  title={() => (
             <> <Button onClick={this.props.showDrawer} type="primary">
                {" "}
                <Icon type="plus" />
                Add new Principal
              </Button> 
              <Button
              onClick={this.sendMail}
              type="primary"
              disabled={!hasSelected}
              style={{marginLeft:20}}
            >
              Send Mail
              
            </Button>  <span style={{ marginLeft: 8 }}>
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </span> 
               <div style={{marginTop:20}}>
                 {profile && profile.role && profile.role != 'ADMIN' ? <Alert
                    message={`This table only showing the Principal's added by you.`}
                    type="info">
                </Alert> : null}
               
                 </div> <><Search
         placeholder="Search in table"
         enterButton="Search"
         size="large"
         style={{width:'85%',marginRight:10}}
         allowClear 
         onSearch={value => this.searchTable(value,this.props.data)}
       /><Button style={{background:'#001529',color:'white'}} onClick={()=>message.info('Feature not yet available. Coming soon')}  type="dashed" icon="download" size="large">Export to Excel</Button></>
                </>
            )}  bordered style={{ margin: 20, background: "#f9f9f9", padding: 20 }} scroll={{ x: true }}  rowSelection={rowSelection}   columns={columns} dataSource={tableData} onChange={this.handleChange} /> : null}
      </div>
    );
    }
}
 
export default GenTable;